import edm from '@bingads-webui-component-legacy/edm-campaign/index';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import { ResponsiveSearchAdStrengthView } from '@bingads-webui-campaign/responsive-search-ad-strength';
import appState from '@bingads-webui-component-legacy/state/index';
import pageContext from '@bingads-webui-static-legacy/page-context';

const i18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/responsive-search-ad');

export default function buildAdStrength(adId, viewModel, isForVNext = false, inlineSuggestionsEnabled = false) {
  return new ResponsiveSearchAdStrengthView({
    adId,
    edm,
    i18n,
    jsdata,
    viewModel,
    isForVNext,
    inlineSuggestionsEnabled,
    appState,
    token: pageContext.Token,
    odataPath: pageContext.BingAdsAdInsightWebApiUri,
  });
}
